module.exports = __webpack_public_path__ + "static/media/ico_enter.d8dfcc0d.svg";